import { Typography } from 'antd';
import PropTypes from 'prop-types';
import listErrorType from 'Helpers/ErrorList';
import { StyleWrap } from './style';

function PanicContent({ type }) {
  const { Title, Paragraph } = Typography;
  return (
    <StyleWrap>
      <div className="page-body">
        <div className="content">
          {type in listErrorType && (
            <>
              <img src={listErrorType[type].imagePath} alt={listErrorType[type].altImage} />
              <div className="alert-message">
                <Title level={4}>{listErrorType[type].titleContent}</Title>
                <Paragraph>{listErrorType[type].paragraphContent}</Paragraph>
                {type !== '403' &&
                <Paragraph>
                  {listErrorType[type].linkLabel !== '' && <a href={listErrorType[type].linkTo}>{listErrorType[type].linkLabel}</a>}
                </Paragraph>
                }
              </div>
            </>
          )}
        </div>
      </div>
    </StyleWrap>
  );
}

PanicContent.propTypes = {
  type: PropTypes.string.isRequired,
};

export default PanicContent;
